export function IsProduction(): boolean {
    return process.env.REACT_APP_NODE_ENV === "production";
}

export function IsDevelopment(): boolean {
    return !IsProduction();
}


// WEBPACK FOOTER //
// ./src/util/Environment.ts